import { render } from "./LoginPage.vue?vue&type=template&id=343fee9c"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"
script.render = render

export default script